import EventEmitter from 'events';

// Standard observer pattern, the nudges will invoke this
// to change visibility of scroll element or scroll to the point
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default new EventEmitter();
